var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFotoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 4H3.99902C2.89602 4 1.99902 4.897 1.99902 6V18C1.99902 19.103 2.89602 20 3.99902 20H19.999C21.102 20 21.999 19.103 21.999 18V6C21.999 4.897 21.102 4 19.999 4ZM6.49902 7C6.89685 7 7.27838 7.15804 7.55968 7.43934C7.84099 7.72064 7.99902 8.10218 7.99902 8.5C7.99902 8.89782 7.84099 9.27936 7.55968 9.56066C7.27838 9.84196 6.89685 10 6.49902 10C6.1012 10 5.71967 9.84196 5.43836 9.56066C5.15706 9.27936 4.99902 8.89782 4.99902 8.5C4.99902 8.10218 5.15706 7.72064 5.43836 7.43934C5.71967 7.15804 6.1012 7 6.49902 7ZM11.999 17H4.99902L8.99902 12L10.499 14L13.499 10L18.999 17H11.999Z",
    fill: "#929191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFotoIcon);
export default __webpack_public_path__ + "static/media/foto-icon.d0547cca140492fbbe81e2836d4eb8b4.svg";
export { ForwardRef as ReactComponent };